import { useGlobalQuery } from '@/state/query-client/hooks';
import { getLeaveCategoriesLookup } from '../services/leave-lookups.service';

/**
 * Leave categories of the active organization, which stands for the employee's country of employment.
 * `categories` stays undefined until they have loaded, or while `enabled` is false.
 */
export const useLeaveCategoriesLookup = (enabled = true) => {
  const { data: categories, isLoading } = useGlobalQuery({
    queryKey: ['hr-directory-leave-categories'],
    queryFn: getLeaveCategoriesLookup,
    enabled,
    // The Leave Builder owns these and does not know this cache, so it is refetched whenever the
    // HR Info tab opens instead of being trusted for a few minutes.
    staleTime: 0,
  });
  return { categories, isLoading };
};
